import { render } from "./MessageDialogue.vue?vue&type=template&id=2625b7e0&scoped=true"
import script from "./MessageDialogue.vue?vue&type=script&lang=js"
export * from "./MessageDialogue.vue?vue&type=script&lang=js"

import "./MessageDialogue.vue?vue&type=style&index=0&id=2625b7e0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2625b7e0"]])

export default __exports__